module.exports = __webpack_public_path__ + "img/bg_sanfang.9d3e08fd.png";